module.exports = __webpack_public_path__ + "img/I-25.9f0e7e2d.svg";